import React from 'react';

import styles from './footer.module.css';

import SocialIcons from '../SocialIcons';

const Footer = () => (
    <div className={styles.footer}>
        <SocialIcons />
        <ul className={styles.contactInfo}>
            <li><a href="tel:+447490117166">+44 (0) 7490 117166</a></li>
            <li><a href="mailto:hello@artiseq.com">hello@artiseq.com</a></li>
        </ul>
        <p>Copyright &copy; 2018. All rights reserved.</p>
    </div>
)

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js